import { Response } from '@marketplace-web/core-api/api-client-util'

import { FeedbackRatingModel, FeedbackRatingFormDto } from '../types/help-center-feedback'

import { GetOfflineVerificationFeedbackResp } from '../types/offline-verification-feedback'
import { FeedbackRatingOptionsResp } from '../types/feedback-rating'

// Note: Duplicate transformer utility to avoid circular dependency violation
const transformFeedbackFormRatingsData = ({
  available_statements,
  form_subtitle,
  form_title,
}: FeedbackRatingFormDto): FeedbackRatingModel => {
  const ratingIds: Array<number> = []

  const ratingOptions = available_statements.reduce((previousValue, currentValue) => {
    ratingIds.push(currentValue.rating_id)

    const mappedRatingOptions = currentValue.options.map(option => {
      const { id, body, has_message_input } = option

      return {
        id,
        body,
        hasMessageInput: has_message_input,
      }
    })

    return {
      ...previousValue,
      [currentValue.rating_id]: {
        title: currentValue.title,
        options: mappedRatingOptions,
      },
    }
  }, {})

  return {
    titleText: form_title,
    subtitleText: form_subtitle,
    ratingOptions,
    ratingIds,
  }
}

export const transformFeedbackRatingsResponse = (
  response: Response<FeedbackRatingOptionsResp | GetOfflineVerificationFeedbackResp>,
): FeedbackRatingModel | undefined => {
  if (!response.feedback_ratings) return undefined

  return transformFeedbackFormRatingsData(response.feedback_ratings)
}
